"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var productHighlightConfig = [
    {
        key: 'textColor',
        type: 'color',
        label_ar: 'CTA Text Color',
        label_en: 'CTA Text Color',
        required: false,
        sort: 5,
    },
    {
        key: 'moduleHeader',
        type: 'group',
        label_ar: 'Module Header',
        label_en: 'Module Header',
        required: true,
        is_virtual: true,
        values: [
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
            },
            {
                key: 'titleColor',
                type: 'color',
                label_ar: 'Title Text Color',
                label_en: 'Title Text Color',
                required: false,
            },
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'CTA Text',
                label_en: 'CTA Text',
                required: false,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'CTA Url',
                label_en: 'CTA Url',
                required: false,
            },
            {
                key: 'textColor',
                type: 'color',
                label_ar: 'CTA Text Color',
                label_en: 'CTA Text Color',
                required: false,
            },
            {
                key: 'linkBgColor',
                type: 'color',
                label_ar: 'CTA Background Color',
                label_en: 'CTA Background Color',
                required: false,
            },
            // Not including this, do not like image in header
            // Just make another banner widget
            {
                key: 'titleImageUrl',
                type: 'image',
                label_ar: 'Title Image',
                label_en: 'Title Image',
                required: false,
                is_virtual: true,
            },
        ],
    },
    // Virtual as no use for this yet as not looking into analysis
    {
        key: 'widgetId',
        type: 'number',
        label_ar: 'Widget ID',
        label_en: 'Widget ID',
        required: false,
        is_virtual: true,
    },
];
exports.default = productHighlightConfig;
//# sourceMappingURL=config.js.map